import useFeatureToggle from 'hooks/useFeatureToggle';
import React from 'react';
import { Route } from 'react-router-dom';
import lazyLoad from 'utils/lazyLoad';
import { getRouterPath } from 'utils/navigation';

const ProductPlans = lazyLoad(
  () => import(/* webpackChunkName: "ProductPlans" */ 'pages/ProductPlans'),
);

const PlanUpgrade = lazyLoad(
  () =>
    import(
      /* webpackChunkName: "PlanUpgrade" */ 'pages/ProductPlans/PlanUpgrade'
    ),
);

export default function useProductPlanRoutes() {
  const isAccountSettingsEnabled = useFeatureToggle('ENABLE_ACCOUNT_SETTINGS');
  const isAdminAccountUpgradeEnabled = useFeatureToggle(
    'ENABLE_ADMIN_ACCOUNT_UPGRADE',
  );

  return [
    isAccountSettingsEnabled && (
      <Route
        path={getRouterPath('/PlanOverviewPlace:none')}
        component={ProductPlans}
      />
    ),
    isAdminAccountUpgradeEnabled && (
      <Route
        exact
        path={[
          getRouterPath('/planUpgrade/:purchaseJourneyStep?'),
          getRouterPath('/PlanUpgradePlace/:purchaseJourneyStep?'),
        ]}
        component={PlanUpgrade}
      />
    ),
  ];
}
